import { render, staticRenderFns } from "./GlobalLoader.vue?vue&type=template&id=2543dbb0&scoped=true&"
import script from "./GlobalLoader.vue?vue&type=script&lang=js&"
export * from "./GlobalLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2543dbb0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VProgressLinear,VSnackbar})
